import type { LensCardView } from '~/types/leLens';

import { parseGrain } from '../lensGrain';

/** Fields used by the current draft, including filters and ratio components.
 *
 * `x`/`series`/`value` can each hold a grain expression ("week(transaction_date)") rather than
 * the bare column, so each is unwrapped with `parseGrain` first: a card grouping by week still
 * marks `transaction_date` as in use, the field this set exists to answer for. */
export function fieldBrowserUsedNames(view: LensCardView): Set<string> {
  return new Set([
    ...[view.x, view.series, view.value]
      .map((name) => (name ? (parseGrain(name)?.column ?? name) : undefined))
      .filter((name): name is string => Boolean(name)),
    ...[view.ratio?.of, view.ratio?.per].filter((name): name is string => Boolean(name)),
    ...(view.values ?? []),
    ...(view.where?.map((clause) => clause.column) ?? []),
  ]);
}
